exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4241d28a] .el-upload{width:100%!important}[data-v-4241d28a] .el-upload .el-upload-dragger{width:100%!important;height:210px!important}[data-v-4241d28a] .el-upload-list{padding:0 10px!important}", ""]);

// exports
